import {
  COMFORT_CREDITS_CHANGE_VALUE,
  COMFORT_CREDITS_CHANGE_VALUES,
  COMFORT_CREDITS_CHANGE_TABLE_OPTION,
  VOUCHERS_CHANGE_TABLE_OPTION,
} from '@/store/constants/mutationTypes';

const mutations = {
  [COMFORT_CREDITS_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  [COMFORT_CREDITS_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [COMFORT_CREDITS_CHANGE_TABLE_OPTION]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state.ccTableOptions[field] = value;
  },
  [VOUCHERS_CHANGE_TABLE_OPTION]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state.voucherTableOptions[field] = value;
  },
};

export default mutations;
